import React from 'react';
import PropTypes from 'prop-types';

// Карточка точки/перехода Дозора (.dz-card): номер, название, мета.
export default function DozorCard({ num, title, meta, onClick }) {
    return (
        <div className="dz-card" role="button" tabIndex={0} onClick={onClick} onKeyDown={(e) => { if (e.key === 'Enter') onClick(); }}>
            <span className="dz-num">{num}</span>
            <div className="dz-info">
                <div className="dz-name">{title || 'Без названия'}</div>
                {meta && <div className="dz-meta">{meta}</div>}
            </div>
        </div>
    );
}

DozorCard.propTypes = {
    num: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    title: PropTypes.string,
    meta: PropTypes.node,
    onClick: PropTypes.func.isRequired
};

DozorCard.defaultProps = { title: '', meta: null };
